import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { LocalParkingFeeManualCalculatePayload } from '../../../models/parking/local-parking-fee-calc.model';

@Injectable({ providedIn: 'root' })
export class ApiParkingFeeCalculationService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  private get token(): string {
    return this.cookieService.get('token');
  }

  /** คำนวณจาก transaction จริง */
  calculateByTransaction(transactionId: number, siteId: number): Observable<unknown> {
    return this.apiMethodService.request('/ParkingFeeCalculation/calculate', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'calculateLocalParkingFee',
      token: this.token,
      headerOnly: false,
      params: { transactionId, siteId },
    });
  }

  /** ทดสอบคำนวณโดยไม่มี transaction — ใช้เครื่องคำนวณชุดเดียวกับ calculate */
  calculateManual(payload: LocalParkingFeeManualCalculatePayload): Observable<unknown> {
    return this.apiMethodService.request('/ParkingFeeCalculation/calculateManual', 'POST', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'calculateLocalParkingFeeManual',
      token: this.token,
      headerOnly: false,
      body: payload,
    });
  }
}
